<template>
  <div class="fill_form mt20 m0 mb30 clearfix" key="retireSee">
    <ul class="fr operation_list">
      <li class="fl"><router-link :to="{name:'add',params:{type:'retire',index:'1',status:'edit',id:id}}">修改</router-link></li>
      <li class="fl" @click="delPerson">删除</li>
      <li class="fl" @click="payStop">待遇终止</li>
    </ul>
    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>基本信息
    </h3>

    <!-- 标题 end-->
    <div class="fill_group_row clearfix fl w_half">

      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>姓名</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input time_icon" disabled v-model="userInfo.user.username" id="lord_company" type="text"/>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>性别</label>
        <div class="form_control w_auto ">
          <select class="i_w300 form_select time_icon" disabled v-model="userInfo.user.sex">
            <option value="1">男</option>
            <option value="2">女</option>
          </select>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>民族</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input time_icon" disabled v-model="userInfo.user.nation" type="text"/>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>参加工作日期</label>
        <div class="form_control w_auto ">
          <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model="userInfo.user.work_time" name="date"></vue-datepicker-local>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>工作单位</label>
        <div class="form_control w_auto ">
          <select class="i_w300 form_select time_icon" disabled v-model='userInfo.user.company_id' name="company_id" required>
            <option value="0">请选择</option>
            <option v-for="(value,index) in companyData" :value="value.id">{{value.company_name}}</option>
          </select>
        </div>
      </div>

    </div>
    <div class="fill_group_row clearfix fr w_half">

      <!--<div class="form_group clearfix">-->
        <!--<label class="control_label "><em>*</em>居民身份证</label>-->
        <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input time_icon" disabled id="" type="text" v-model="userInfo.user.idcard"/>-->
        <!--</div>-->
      <!--</div>-->
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>社会保障号</label>
        <input class="i_w300 form_input" disabled type="text" v-model="userInfo.user.social_security_account"/>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>出生日期</label>
        <div class="form_control w_auto ">
          <vue-datepicker-local class="i_w300 form_input date_picker_out" v-model='userInfo.user.birthday' disabled name="date"></vue-datepicker-local>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>邮政编码</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input" type="text" disabled v-model='userInfo.user.postal_code'/>
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>联系手机</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input" disabled type="text" v-model="userInfo.user.mobile" />
        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label ">固定电话</label>
        <div class="form_control w_auto ">
          <input class="i_w300 form_input"  type="text" disabled v-model='userInfo.user.telephone'/>
        </div>
      </div>

      <!--<div class="form_group clearfix">-->
        <!--<label class="control_label "><em>*</em>工作单位</label>-->
        <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input" type="text" disabled v-model='userInfo.user.work_unit_name'/>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <div class="fill_group_row clearfix">
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>户籍所在地</label>
        <div class="form_control w_auto">

          <div class="flex fl">
            <div class="w_375">
              <select class="form_select s_w120" name="" disabled v-model='userInfo.user.domicile_province'>
                <option value="">省</option>
                <option v-for="(item,index) in areas.allArr" :value="index">
                  {{item.name}}
                </option>
              </select>
              <select class="form_select s_w120" name="" disabled v-model='userInfo.user.domicile_city'>
                <option value="">市</option>
                <option v-for="(item,index) in areas.domicileCities" :value="index">{{item.name}}</option>
              </select>
              <select class="form_select s_w120" name="" disabled v-model='userInfo.user.domicile_district'>
                <option value="">区</option>
                <option v-for="(item,index) in areas.domicileDistrict" :value="index">{{item.name}}</option>
              </select>
            </div>
            <div class="auto_flex">
              <input class=" form_input time_icon w100" disabled type="text"  v-model='userInfo.user.domicile_detail'/>
            </div>

          </div>

        </div>
      </div>
      <div class="form_group clearfix">
        <label class="control_label "><em>*</em>通讯地址</label>
        <div class="form_control w_auto">

          <div class="flex fl">
            <div class="w_375">
              <select class="form_select s_w120" disabled name="" v-model="userInfo.user.address_province">
                <option value="">省</option>
                <option v-for="(item,index) in areas.allArr" :value="index">
                  {{item.name}}
                </option>
              </select>
              <select class="form_select s_w120" disabled name="" v-model="userInfo.user.address_city">
                <option value="">市</option>
                <option v-for="(item,index) in areas.addressCities" :value="index">{{item.name}}</option>

              </select>
              <select class="form_select s_w120" disabled name="" v-model="userInfo.user.address_district">
                <option value="">区</option>
                <option v-for="(item,index) in areas.addressDistrict" :value="index">{{item.name}}</option>

              </select>
            </div>
            <div class="auto_flex">
              <input class=" form_input time_icon w100" disabled type="text" v-model="userInfo.user.address_detail"/>
            </div>

          </div>

        </div>
      </div>
    </div>


    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>2014年9月30日前人事信息
    </h3>
    <!-- 标题 end-->
    <div class="clearfix">
      <div class="fill_group_row clearfix fl w_half">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>改革时人员类别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" @change="getPositionInfo(userInfo.special.type,'special')" disabled v-model="userInfo.special.type">
              <option value="1">事业单位专业技术人员</option>
              <option value="2">事业单位管理人员</option>
              <option value="3">事业单位工人</option>
            </select>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>2014年9月岗位级别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" v-model="userInfo.special.position_id" name="dutiesType" disabled>
              <option value=0>请选择</option>
              <option v-for="(value,index) in positionInfo1" :value="index">{{value}}</option>
            </select>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>改革时基本工资</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" disabled name="basicWage" v-model="userInfo.special.basic_wage" type="text"/>元
          </div>
        </div>
      </div>
      <div class="fill_group_row clearfix fr w_half">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>改革时薪级</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" v-model="userInfo.special.salary_level" type="text" name="dutiesLevel" disabled>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>改革时退休补贴</label>
          <input class="i_w300 form_input" disabled v-model="userInfo.special.retirement_allowance" name="retirementAllowance" type="text"/>元
        </div>

      </div>
    </div>
    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>退休信息
    </h3>
    <!-- 标题 end-->
    <div class="clearfix">
      <div class="fill_group_row clearfix fl w_half">
        <div tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>变更类型</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" name="changeType" disabled v-model="userInfo.retirement.change_type">
              <option value="1">在职转退休</option>
            </select>
          </div>
        </div>
        <div tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>退休类型</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" name="retirementsType" disabled v-model="userInfo.retirement.retirement_type">
              <option value="0">请选择</option>
              <option v-for="(value,index) in retiredType" :value="index">{{value}}</option>
            </select>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>退休时人员类别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" name="retirementsType" @change="getPositionInfo(userInfo.retirement.rank,'retirement')" disabled v-model="userInfo.retirement.rank">
              <option value=0>请选择</option>
              <option value="1">事业单位专业技术人员</option>
              <option value="2">事业单位管理人员</option>
              <option value="3">事业单位工人</option>
            </select>
          </div>
        </div>
        <div tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>退休岗位级别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" v-model="userInfo.retirement.position_id" name="positionId" disabled pattern="^[1-9]\d*$">
              <option value=0>请选择</option>
              <option :value="index" v-for="(value,index) in positionInfo2">{{value}}</option>

            </select>
          </div>
        </div>
        <div tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>退休日期</label>
          <div class="form_control w_auto ">
            <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model="userInfo.retirement.date" name="retirementDate"></vue-datepicker-local>
          </div>
        </div>
        <div tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>待遇开始日期</label>
          <div class="form_control w_auto ">
            <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model="userInfo.retirement.treatment_start_time" name="treatmentStartTime"></vue-datepicker-local>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>国办发【2015】3号文增加的退休费</label>
          <div class="form_control w_auto ">
            <input class=" form_input time_icon i_w300" disabled name="extraAllowance" v-model="userInfo.special.extra_allowance" type="text"/>元
          </div>
        </div>
      </div>
      <div class="fill_group_row clearfix fr w_half">
        <div tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>补发开始日期</label>
          <div class="form_control w_auto ">
            <vue-datepicker-local class="i_w300 form_input date_picker_out" disabled v-model="userInfo.retirement.reissue_start_time" name="treatmentStartTime"></vue-datepicker-local>
          </div>
        </div>
        <div tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>退休时薪级</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" disabled name="basicWage" v-model="userInfo.retirement.salary_level" type="text"/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>视同缴费年限</label>
          <div class="form_control w_auto">
            <div tag="div" class="fl" style="position: relative;">
              <input class="form_input s_w120" name="payment_years" type="text"  disabled v-model="userInfo.retirement.payment_years">
              年
            </div>
            <div tag="div" class="fl ml20" style="position: relative; margin-left: 4px;">
              <input class="form_input s_w120" name="payment_months" type="text" disabled v-model="userInfo.retirement.payment_months">
              月
            </div>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>实际缴费年限</label>
          <div class="form_control w_auto">
            <div tag="div" class="fl" style="position: relative;">
              <input class="form_input s_w120" name="actual_payment_years" type="text"  disabled v-model="userInfo.retirement.actual_payment_years">
              年
            </div>
            <div tag="div" class="fl ml20" style="position: relative; margin-left: 4px;">
              <input class="form_input s_w120" name="actual_payment_months" type="text"  disabled v-model="userInfo.retirement.actual_payment_months">
              月
            </div>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>累计缴费年限</label>
          <div class="form_control w_auto">
            <div tag="div" class="fl" style="position: relative;">
              <input class="form_input s_w120" name="accumulated_payment_years" type="text" disabled v-model="userInfo.retirement.accumulated_payment_years" >
              年
            </div>
            <div tag="div" class="fl ml20" style="position: relative; margin-left: 4px;">
              <input class="form_input s_w120" name="accumulated_payment_months" type="text" disabled v-model="userInfo.retirement.accumulated_payment_months">
              月
            </div>
          </div>
        </div>

        <div class="form_group clearfix">

          <label class="control_label "><em>*</em>退休补贴</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" disabled v-model="userInfo.retirement.retirement_allowance" type="number"/>
          </div>
        </div>



      </div>
    </div>
    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>过渡期最后一次职务升降级信息
    </h3>
    <!-- 标题 end-->

    <div class="form_group clearfix">
      <label class="control_label " style="width: 154px;padding-right: 8px;">是否有过渡期</label>
      <div class="form_control w_auto ">
        <select class="i_w300 form_select time_icon" disabled @change="changeInterim()" v-model="userInfo.period.transition">
          <option value="0">请选择</option>
          <option value="1">是</option>
          <option value="2">否</option>
        </select>
      </div>
    </div>

    <div class="clearfix" v-show="interim">
      <div class="fill_group_row clearfix fl w_half">
        <div class="form_group clearfix">
          <label class="control_label " style="width: 154px;">人员类别</label>
          <div class="form_control w_auto ">
            <select class="i_w280 form_select time_icon" disabled @change="getPositionInfo(userInfo.period.type,'period')" v-model="userInfo.period.type">
              <option value="1">事业单位专业技术人员</option>
              <option value="2">事业单位管理人员</option>
              <option value="3">事业单位工人</option>
            </select>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label " style="width: 154px;"><em>*</em>最后一次职务升降信息</label>
          <div class="form_control w_auto ">
            <select class="i_w280 form_select time_icon" disabled v-model="userInfo.period.position_change_last" name="positionChangeLast" pattern="^[1-9]\d*$">
              <option value="0">请选择</option>
              <option :value="index" v-for="(value,index) in positionInfo3">{{value}}</option>
            </select>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label " style="width: 154px;"><em>*</em>升降后职务对应的2014年9月基本工资标准</label>
          <div class="form_control w_auto ">
            <input class="i_w280 form_input time_icon" disabled v-model="userInfo.period.position_change_basic_wage" name="basicWage" type="text"/>元
          </div>
        </div>
      </div>
      <div class="fill_group_row clearfix fr w_half">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>职务升降时间</label>
          <div class="form_control w_auto ">
            <vue-datepicker-local class="i_w280 form_input date_picker_out" disabled v-model="userInfo.period.position_change_time" name="positionChangeTime"></vue-datepicker-local>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>薪级</label>
          <div class="form_control w_auto ">
            <input class="i_w280 form_input time_icon" v-model="userInfo.period.salary_level" type="text" name="dutiesLevel" disabled>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>退休补贴</label>
          <input class="i_w280 form_input" v-model="userInfo.period.retirement_allowance" disabled name="retirementAllowance" type="text"/>元
        </div>

      </div>
    </div>

    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>老办法待遇信息
    </h3>
    <!-- 标题 end-->
    <div class="clearfix">
      <div class="fill_group_row clearfix fl w_half">
        <div class="form_group clearfix">
          <label class="control_label ">是否军转干部</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" disabled v-model="userInfo.oldMethod.military_cadres">
              <option value="0">请选择</option>
              <option value="1">是</option>
              <option value="2">否</option>
            </select>
          </div>
        </div>


        <div class="form_group clearfix" :class="[ turnDry ? 'shiftShow' : 'shiftHide' ]">
          <label class="control_label ">转业时间</label>
          <div class="form_control w_auto ">
            <input class="form_input i_w300" disabled type="text" v-model="userInfo.oldMethod.military_revolution_time" >
          </div>
        </div>
        <div class="form_group clearfix" :class="[ turnDry ? 'shiftShow' : 'shiftHide' ]">

          <label class="control_label ">转业时部队技术等级</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select"  type="text"  disabled v-model="userInfo.oldMethod.military_rank" >
              <option value=0>请选择</option>
              <option :value="item.id" v-for="(item,index) in techRank">{{item.level}}</option>
            </select>
          </div>
        </div>

      </div>
      <div class="fill_group_row clearfix fr w_half">
        <!--<div tag="div" class="form_group clearfix">-->
          <!--<label class="control_label ">老办法养老金</label>-->
          <!--<div class="form_control w_auto ">-->
            <!--<input class="i_w300 form_input time_icon" disabled v-model="userInfo.oldMethod.old_method_pension" name="oldMethodPension" type="text"/>-->
          <!--</div>-->
        <!--</div>-->
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>计发比例</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" disabled v-model="userInfo.oldMethod.proportion" name="proportion" type="text"/>
          </div>
        </div>


        <div class="form_group clearfix" :class="[ turnDry ? 'shiftShow' : 'shiftHide' ]">

          <label class="control_label ">转业时部队职务</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select" name="positionName" type="text"  disabled v-model="userInfo.oldMethod.military_position" >
              <option value=0>请选择</option>
              <option :value="item.id" v-for="(item,index) in positionArmy">{{item.level}}</option>
            </select>
          </div>

        </div>

      </div>
    </div>

    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>新办法待遇信息
    </h3>
    <!-- 标题 end-->
    <div class="clearfix">
      <div class="fill_group_row clearfix fl w_half">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>退休时人员类别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" name="retirementType" disabled v-model="userInfo.newMethod.retirement_type">
              <option value="0">请选择</option>
              <option v-for="(value,index) in retiredType" :value="index">{{value}}</option>
            </select>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>职业年金储存额</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.newMethod.profession_account_storage" disabled name="profession_account_storage" type="text" />元
          </div>
        </div>
        <!--<div class="form_group clearfix">-->
          <!--&lt;!&ndash;<label class="control_label "><em>*</em>实际平均缴费指数</label>&ndash;&gt;-->
          <!--<label class="control_label "><em>*</em>实际缴费指数</label>-->
          <!--<div class="form_control w_auto ">-->
            <!--<input class="i_w300 form_input" v-model="userInfo.newMethod.actual_average_payment_index" disabled name="averagePaymentIndex" type="text" />-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="form_group clearfix">
          <label class="control_label "><em>*</em>上年度在岗平均工资</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.newMethod.average_wage_lastyear" disabled name="averageWageLastyear" type="text" />
          </div>
        </div>-->
        <!--<div class="form_group clearfix">-->
          <!--<label class="control_label "><em>*</em>计发月数</label>-->
          <!--<div class="form_control w_auto ">-->
            <!--<input class="i_w300 form_input" v-model="userInfo.newMethod.months" disabled name="months" type="text" />-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="fill_group_row clearfix fr w_half">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>个人账户储存额</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.newMethod.personal_account_storage" disabled name="personalAccountStorage" type="text" />元
          </div>
        </div>

      </div>
    </div>

    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>新老对比信息
    </h3>
    <!-- 标题 end-->
    <div class="clearfix">
      <div class="fill_group_row clearfix fl w_half">
        <div class="form_group clearfix">
          <label class="control_label ">核定养老金</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.contrast.approved_pension" type="text" disabled/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">补扣发总月数</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.contrast.months" type="text" disabled/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">平均每月补扣发</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.contrast.average_account" type="text" disabled/>
          </div>
        </div>
      </div>
      <div class="fill_group_row clearfix fr w_half">
        <div class="form_group clearfix">
          <label class="control_label "></label>
        </div>
        <!--<div class="form_group clearfix">-->
          <!--<label class="control_label ">发给金额</label>-->
          <!--<div class="form_control w_auto ">-->
            <!--<input class="i_w300 form_input" v-model="userInfo.contrast.amount" type="text" disabled/>-->
          <!--</div>-->
        <!--</div>-->
        <div class="form_group clearfix">
          <label class="control_label ">实发养老金</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.contrast.real_pension" type="text" disabled/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">补扣发总金额</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.contrast.account" type="text" disabled/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "></label>
        </div>
      </div>
    </div>

    <!--标题-->
    <h3 class="form_title clearfix"><span>| </span>银行账户信息
    </h3>
    <!-- 标题 end-->
    <div class="clearfix">
      <div class="fill_group_row clearfix fl w_half">
        <div class="form_group clearfix">
          <label class="control_label ">发放银行</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.bank.issuing_bank" type="text" disabled/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">开户名</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.bank.bank_username" type="text" disabled/>
          </div>
        </div>
        <!--<div class="form_group clearfix">-->
          <!--<label class="control_label ">开户行名称</label>-->
          <!--<div class="form_control w_auto ">-->
            <!--<input class="i_w300 form_input" v-model="userInfo.bank.bank_name" type="text" disabled/>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="fill_group_row clearfix fr w_half">
        <div class="form_group clearfix">
          <label class="control_label ">银行账号</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.bank.bank_account" type="text" disabled/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">开户行行号</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" v-model="userInfo.bank.bank_number" type="text" disabled/>
          </div>
        </div>
      </div>
    </div>


    <h3 class="form_title clearfix"><span>| </span>当月实发养老金待遇明细
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th>开始年月</th>
          <th colspan="2">待遇项目</th>
          <th>金额</th>
        </tr>
        <tr>
          <td rowspan="5">{{toMonthDate}}</td>
          <td rowspan="3">老办法</td>
          <td>浙政发【2015】25号文件规定的老办法计发待遇标准Q</td>
          <td>{{toMonthSendDetail.old_total_q}}</td>
        </tr>
        <tr>
          <td>职务升降前后累计待遇差H</td>
          <td>{{toMonthSendDetail.old_cumulative_diff_h}}</td>
        </tr>
        <tr>
          <td>最终老办法待遇标准Q+H</td>
          <td>{{toMonthSendDetail.old_q_h}}</td>
        </tr>
        <tr>
          <td rowspan="2">新办法</td>
          <td>新办法待遇合计</td>
          <td>{{toMonthSendDetail.new_total}}</td>
        </tr>
        <tr>
          <td>应发月养老金合计</td>
          <td>{{toMonthSendDetail.total_pension}}</td>
        </tr>
      </table>
    </div>
    <h3 class="form_title clearfix"><span>| </span>历史发放明细
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th v-for="tableTittle in tableTittles2">{{tableTittle}}</th>
        </tr>
        <tr v-for="(item,index) in historySendDetail">
          <td>{{item.create_time.split(' ')[0].split('-')[0]}}-{{item.create_time.split(' ')[0].split('-')[1]}}</td>
          <td>{{item.total_pension}}</td>

        </tr>

      </table>
      <Pagination :total="listcount" :pagesize="pagesize" :pagegroup="pagegroup" @pagechange="pagechange"></Pagination>
    </div>


    <vue-form :state="formstate">
    <msgTips v-show="showMsg" @confirm="ensureStop" @cancel="closeLayer"  mheight="300" title="待遇终止" >

      <validate tag="div" class=" form_group clearfix">
        <label class="control_label "><em>*</em>待遇终止时间</label>
        <div class="form_control w_auto ">
          <input class="i_w260 form_input" required name="stopTime" type="text" v-model="userInfo.user.stop_time" :disabled="disabled" />
          <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model="userInfo.user.stop_time" name="stopTime" disabled="disabled"></vue-datepicker-local>-->
          <field-messages name="stopTime" show="$dirty || $touched || $submitted">
            <div slot="required" class="errorMessage">待遇终止时间不能为空</div>
          </field-messages>
        </div>
      </validate>



        <validate tag="div" class="form_group clearfix w_half">
          <label class="control_label "><em>*</em>终止原因</label>
          <div class="form_control w_auto ">
            <input class="i_w260 form_input" required name="stopReason" type="text" v-model="userInfo.user.stop_reason" :disabled="disabled">
            <field-messages name="stopReason" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">终止原因不能为空</div>
            </field-messages>
          </div>
        </validate>

    </msgTips>
    </vue-form>

    <h3 class="form_title clearfix"><span>| </span>工资申报信息</h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th v-for="tableTittle in tableTittles">{{tableTittle}}</th>
        </tr>
        <template v-for="(item,index) in mPaymentList">
          <tr v-if="!item.flag">
            <td>{{item.year}}</td>
            <td>{{item.wages_pay}}</td>
            <td>{{item.base_pay}}</td>
            <td>{{item.start_time}}</td>
            <td>{{item.end_time}}</td>
            <td v-show="retirePaymentHandleHide"><span @click="delPaymentItem(index)" style="cursor: pointer;">删除</span></td>

          </tr>
          <tr v-else>
            <td><input class = 'i_w145 form_input mr10' min="1"  type="number" v-model="item.year"><span style="font-size: 12px;visibility: hidden">保留两位小数点</span></td>
            <td><input class = 'i_w145 form_input mr10' min="1"  type="number" v-on:blur="getBase(item,index)" v-model="item.wages_pay"><span style="font-size: 12px">保留两位小数点</span></td>
            <td><input class = 'i_w145 form_input mr10' min="1"  type="number" v-model="item.base_pay"><span style="font-size: 12px;visibility: hidden">保留两位小数点</span></td>
            <!--<td><vue-datepicker-local class="i_w150 form_input date_picker_out" v-model='item.start_time'></vue-datepicker-local><span style="font-size: 12px;visibility: hidden">数点</span></td>-->
            <td><input class="i_w145 form_input mr10" placeholder="xxxx/xx/xx" type="text" v-model="item.start_time"  /><span style="font-size: 12px;visibility: hidden">数点</span></td>
            <!--<td><vue-datepicker-local class="i_w150 form_input date_picker_out" v-model='item.end_time'></vue-datepicker-local><span style="font-size: 12px;visibility: hidden">数点</span></td>-->
            <td><input class="i_w145 form_input mr10" placeholder="xxxx/xx/xx" type="text" v-model="item.end_time"  /><span style="font-size: 12px;visibility: hidden">数点</span></td>
            <td v-show="retirePaymentHandleHide">
              <span @click="cancelAdd(index)" style="cursor: pointer; margin-right: 10px">取消</span>
              <span @click="complete(index)" style="cursor: pointer;">完成</span>
            </td>
          </tr>
          <!--"-->
        </template>

        <tr v-show="showAdd">
          <td colspan="6" @click="addPaymentItem" style="cursor: pointer;">添加记录</td>
          <!---->
        </tr>

      </table>
    </div>


    <h3 class="form_title clearfix"><span>| </span>计算补收信息
    </h3>
    <div style="margin-bottom: 30px;overflow: auto;">
      <table class="table" >
        <tr>
          <th v-for="tableSupple in tableSupples">{{tableSupple}}</th>
        </tr>
        <tr v-for="(item,index) in  SuppleList.list   ">
          <td>{{item.mouth}}</td>
          <td>{{item.wages_pay}}</td>
          <td>{{item.base_pay}}</td>
          <td>{{item.type}}</td>
          <td>{{Number(item.company_pay).toFixed(2)}}</td>
          <td>{{Number(item.person_pay).toFixed(2)}}</td>
          <td>{{Number(item.total_pay).toFixed(2)}}</td>
        </tr>
        <tr >
          <td class="td_border" colspan='4'>总计：</td>
          <td>{{Number(SuppleList.total_company_pay).toFixed(2)}}</b></td>
          <td>{{Number(SuppleList.total_person_pay).toFixed(2)}}</b></td>
          <td>{{Number(SuppleList.total_pay).toFixed(2)}}</b></td>
        </tr>
      </table>
      <!--<loading v-show="loading"></loading>-->
      <Pagination :total="newlistcount" :pagesize="pagesize" :pagegroup="pagegroup" @pagechange="newpagechange"></Pagination>
    </div>
    <div style="margin-bottom: 30px; ">
      <table class="table" >
        <tr>
          <th v-for="tableSupple in tableSupples">{{tableSupple}}</th>
        </tr>
        <tr v-for="(item,index) in  PensionDetailList.list   ">
          <td>{{item.mouth}}</td>
          <td>{{item.wages_pay}}</td>
          <td>{{item.base_pay}}</td>
          <td>{{item.type}}</td>
          <td>{{Number(item.company_pay).toFixed(2)}}</td>
          <td>{{Number(item.person_pay).toFixed(2)}}</td>
          <td>{{Number(item.total_pay).toFixed(2)}}</td>
        </tr>
        <tr >
          <td class="td_border" colspan='4' >总计：</td>
          <td>{{Number(PensionDetailList.total_company_pay).toFixed(2)}}</td>
          <td>{{Number(PensionDetailList.total_person_pay).toFixed(2)}}</td>
          <td>{{Number(PensionDetailList.total_pay).toFixed(2)}}</td>
        </tr>
      </table>
      <Pagination :total="PenListcount" :pagesize="pagesize" :pagegroup="pagegroup" @pagechange="penPagechange"></Pagination>
    </div>


    <h3 class="form_title clearfix"><span>| </span>操作记录
    </h3>
    <div class="history_info_box">
      <div class="line_box"></div>
      <div class="history_info clearfix" v-for="(item,index) in userInfo.log">
        <div class="history_left">
          <p>{{item.create_time.split(' ')[0]}}</p>
          <p>{{item.create_time.split(' ')[1]}}</p>
        </div>
        <div class="history_right">
          <p class="history_info_tit"><i class="blue_dot"></i><span>{{item.operator_name}}</span></p>
          <p>操作类型：{{item.type==1?'基本更新':item.type==2?'转退休':'转离职'}}</p>
        </div>
      </div>
    </div>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
    <msgTips v-show="showFlag" @confirm="layerConfirm" @cancel="layerCancel" title="提示">
      <p class="layer_content">确认要删除【{{userInfo.user.username}}】的员工信息？删除后不可找回，请谨慎操作</p>
    </msgTips>
    <msgTips v-show="showMflag" @confirm="mLayerConfirm(mIndex)" @cancel="mlayerCancel" title="提示">
      <p class="layer_content">确认要删除该条月缴费记录？删除后不可找回，请谨慎操作</p>
    </msgTips>
  </div>
</template>
<script>
  import VueDatepickerLocal from 'vue-datepicker-local'
  import locations from '../../libs/location_libs'
  import axios from 'axios'
  import qs from 'qs'
  import toastTips from '../../components/layer/toastTips'
  import msgTips from '../../components/layer/msgTips'
  import Pagination from '../../libs/pagination'
  import moment from 'moment'


  export default {
    name:'retireSee',
    components:{
      VueDatepickerLocal,
      toastTips,
      msgTips,
      Pagination
    },
    data(){
      return {
        tableTittles:['年度','缴费工资','缴费基数','开始年月','终止年月','操作'],
        mPaymentList: [],
        showAdd:true,
        showMflag: false,
        retirePaymentHandleHide: true,

        tableTittles1:['开始年月','待遇项目','金额'],
        tableTittles2:['费款所属期','支付金额'],
        tableSupples:['年度','缴费工资','缴费基数','险种类型','单位应缴金额','个人应缴金额','总金额'],
        SuppleList:{},
        PensionDetailList:{},
        newlistcount:0,
        PenListcount:0,
        newpageNo:1,
        penPageNo:1,
        areas:{
          allArr:locations.locations,
          domicileCities:'',
          addressDistrict:'',
          domicileDistrict:'',
          addressCities:''
        },
        positionArmy:[],
        pensionAdjustmentArr:[],
        techRank:[],
        turnDry:false,
        interim:false,
        formstate:{},
        disabled:false,
        showMsg:false,
        report_province:'',
        report_city:'',
        report_area:'',
        toast:false,
        showFlag:false,
        toastContent:'',
        companyData:[],
        id:this.$route.params.id,

        userInfo:{
          user:{
            username:'',
            idcard:'',
            type:'',
            sex:1,
            nation:'',
            birthday:'',
            work_time:'',
            mobile:'',
            telephone:'',
            domicile_province:'',
            domicile_city:'',
            domicile_district:'',
            domicile_detail:'',
            company_id:0,
            work_unit_name:'',
            address_province:'',
            address_city:'',
            address_district:'',
            address_detail:'',
            postal_code:'',
            social_security_account:'',
            stop_time:'',
            stop_reason:''
          },
          special:{
            type:0,
            position_id:'',
            basic_wage:'',
            retirement_allowance:'',
            extra_allowance:'',
            salary_level:''
          },
          insurance:{
            insured_time:'',
            first_insured_time:'',
            compilation_type:'',
            account_creation_time:''
          },
          period:{
            type:'',
            position_change_last:1,
            level_change_last:1,
            basic_wage:0,
            retirement_allowance:'',
            increased_retirement_fee:'',
            position_change_time:'',
            salary_level:'',
            position_change_basic_wage:'',
            transition:''
          },
          oldMethod:{
            military_cadres:0,
            old_method_pension:'',
            proportion:'',
            rate:'',
            military_position:'',
            military_rank:'',
            military_revolution_time:''
          },
          newMethod:{
            retirement_type:0,
            contribution_index:'',
            actual_average_payment_index:'',
            average_payment_index:'',
            average_wage_lastyear:'',
            personal_account_storage:'',
            profession_account_storage:'',
            months:'',
            new_method_pension:'',
            basic_pension:'',
          },
          contrast:{
            over_new_method_pension:'',
            proportion:'',
            amount:'',
            approved_pension:'',
            real_pension:'',
            months:'',
            account:'',
            average_account:''
          },
          bank:{
            issuing_bank:'',
            bank_account:'',
            bank_username:'',
            bank_number:'',
            bank_name:''
          },
          retirement:{
            change_type:'',
            retirement_type:'',
            rank:'',
            position_id:'',
            date:'',
            treatment_start_time:'',
            reissue_start_time:'',
            actual_payment_years:'',
            accumulated_payment_years:'',
            accumulated_payment_months:'',
            payment_months:'',
            actual_payment_months:'',
            salary_level:'',
            type:'',
            retirement_allowance:''
          }
        },
        retiredType:{},
        personnelType:{},
        positionInfo1:{},
        positionInfo2:{},
        positionInfo3:{},
        historySendDetail:[],
        listcount:0,
        pagesize:15,
        pagegroup:7,
        pageNo:1,
        toMonthSendDetail:{},
        toMonthDate:'',
      }
    },
    created:function () {


    },
    methods:{
      pagechange:function(currentpage){
        this.pageNo=currentpage;
        this.getPersonList();
      },
      updateCity:function(cities,province){
        this.areas[cities] =this.areas.allArr[province].sub
      },
      updateDistrict:function(district,cities,province){
        this.areas[district] =this.areas.allArr[province].sub[cities].sub
      },
      delPerson:function(){
        this.showFlag=true;
      },
      layerCancel:function(){
        this.showFlag=false;
      },

      // changeCount:function () {
      //   let stopTime =  moment(this.userInfo.user.stop_time).format("YYYY-MM-DD")
      //   console.log(stopTime )
      // },

      layerConfirm:function(){
        var that=this,
          tipBox = document.getElementsByClassName('tipsBox')[0];
        that.showFlag=false;
        axios.post('/user/delete',qs.stringify(
          {
            id:that.id,
            type:2
          }
        )).then((response)=>{
          if(response.data.code==22000){
            that.toastContent='删除成功';
            tipBox.style.display='block';
            setTimeout(function(){
              tipBox.style.display='none';
              window.location.href='/#/list/1';
            },3000);
          }else if(response.data.code == 50001){
            window.location.href='/#/login';
          }else{
            that.toastContent='操作失败';
            tipBox.style.display='block';
            setTimeout(function(){
              tipBox.style.display='none';
            },3000);
          }
        })
      },
      getPositionInfo:function(type,step){
        var that=this;
        console.log(type);
        axios.get('/config/getPersonnelTypeRank',
          {params:{type:type}}
        ).then((response)=>{
          if(response.data.code == 22000){
            if(step=='special'){
              that.positionInfo1 = response.data.result;
            }else if(step=='retirement'){
              that.positionInfo2 = response.data.result;
            }else if(step=='period'){
              that.positionInfo3 = response.data.result;
            }
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }
        })
      },
      getHistoryDetail:function(){
        var that=this;
        axios.get('/user/historyDetails',{
          params:{
            user_id:that.id,
            page:that.pageNo
          }
        }).then((response)=>{
          if(response.data.code == 22000){
            that.historySendDetail=response.data.result.list;
            that.listcount=response.data.result.total;
          } else if(response.data.code==50001){
            window.location.href='/#/login';
          }
        })

      },
      payStop:function () {
        this.showMsg = true;
      },
      ensureStop:function () {
        var that = this;
        that.userInfo.user.stop_time=moment(that.userInfo.user.stop_time).format("YYYY-MM-DD");

        if(!that.formstate.$invalid) {
        axios.post('/user/stopUser',
          {
            user_id: that.id,
            stop_reason: that.userInfo.user.stop_reason,
            stop_time: that.userInfo.user.stop_time
          }
        ).then((response) => {
          if (response.data.code == 22000) {
            console.log(response)
            console.log('查看保存返回')
            this.showMsg = false;
          } else {
            console.log(response.data.message)
          }
        })
      }
      },

      closeLayer:function () {
        this.showMsg = false;
      },

      searchPension:function(){
        axios.get('/user/getAdvance',{
          params:{

            id:this.id
          }
        }).then((response)=>{
          if(response.data.code==22000){
            if(response.data.result.constructor!=Array){
              var times=response.data.result.create_time.split(' ')[0];
              this.toMonthSendDetail=response.data.result;
              this.toMonthDate=times.split('-')[0]+'-'+times.split('-')[1];
            }
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }
        })
      },


      newpagechange:function(currentpage){
        this.newpageNo=currentpage;
          this.getSupplelist();
      },
      penPagechange:function(currentpage){
        this.penPageNo=currentpage;
          this.getPensionDetail();
      },
      getSupplelist:function () {
        var that=this;
        axios.get('/user/getMPaymentDetail',{
            params:{
              user_id:that.id,
              page:that.newpageNo,
              page_num:15
            }
        }
        ).then((response)=>{
          if(response.data.code==22000){
            if(response.data.result){
              that.SuppleList = response.data.result
              that.newlistcount =response.data.result.total
            }else{
              that.SuppleList = {};
            }

          }else if(response.data.code !== 22000){
            that.SuppleList = {};
            console.log(response.data.message)
          }
        })
      },
      getPensionDetail:function () {
        var that=this;
        axios.get('/user/getPensionDetail',{
            params:{
              user_id:that.id,
              page:that.penPageNo,
              page_num:15
            }
        }
        ).then((response)=>{
          if(response.data.code==22000){
            if(response.data.result){
              that.PensionDetailList = response.data.result
              that.PenListcount =response.data.result.total
            }else{
              that.PensionDetailList = {};
            }

          }else if(response.data.code !== 22000){
            that.PensionDetailList = {};
            console.log(response.data.message)
          }
        })
      },
      getMPaymentList:function(){
        var that=this;
        axios.get('/user/getMPaymentList',{
          params:{
            user_id:that.id
          }
        }).then((response)=>{
          if(response.data.code==22000){
            that.mPaymentList=response.data.result
          }
        })
      },
      addPaymentItem:function(){
        var that=this;
        this.mPaymentList.push({
          flag:true,
          start_time:'',
          end_time:'',
          payment_base:'',
          user_id:that.id

        });
        // this.showAdd=false
      },
      delPaymentItem:function(index){
        this.showMflag=true;
        this.mIndex=index;
      },
      getBase:function (item,index) {
        console.log(item)
        let that=this;
        // let lastItem=that.mPaymentList[that.mPaymentList.length-1];
        axios.get('/averageSalary/getYearInfo',{
            params:{
              year:item.year
            }
          }
        ).then((response)=>{
          if(response.data.code==22000){
            let diffValue1 = Number(item.wages_pay)-Number(response.data.result.payment_base_highest)
            let diffValue2 = Number(item.wages_pay)-Number(response.data.result.payment_base_lowest)
            if( diffValue1 >=  0 ){
              this.$set(this.mPaymentList,index ,item)
              let paymentBaseHighest=response.data.result.payment_base_highest
              item.base_pay = paymentBaseHighest
            }else if (diffValue2 <=  0){
              this.$set(this.mPaymentList,index ,item)
              item.base_pay = response.data.result.payment_base_lowest
            }else{
              this.$set(this.mPaymentList,index ,item)
              let wagesPay = Math.round(item.wages_pay*0.1)*10
              item.base_pay = wagesPay

            }
          }else if(response.data.code !== 22000){

          }
        })
      },
      complete:function(index){
        var that=this,
            lastItem=that.mPaymentList[that.mPaymentList.length-1];
            // lastItem.base_pay=lastItem.payment_base;
        if(!lastItem.start_time || !lastItem.end_time || !lastItem.base_pay|| !lastItem.wages_pay|| !lastItem.year){
          that.toast=true;
          that.toastContent='请填写信息';
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000);
          this.showAdd=true;
          return false;
        }

        lastItem.start_time =  moment(lastItem.start_time).format("YYYY-MM-DD")
        lastItem.end_time =  moment(lastItem.end_time).format("YYYY-MM-DD")
        axios.post('/user/addMPayment',qs.stringify(
          lastItem
        )).then((response)=>{
          if(response.data.code==22000){
            this.$set(that.mPaymentList[index],"flag",false);
            this.showAdd=true;
            this.getMPaymentList();
            this.getSupplelist();
            this.getPensionDetail();
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.mPaymentList.pop();
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000);
            this.showAdd=true;
          }
        })
      },
      cancelAdd:function(index){
        this.mPaymentList.splice(index,1);
        this.showAdd=true;
        this.getSupplelist();
        this.getPensionDetail();
      },
      mlayerCancel:function(){
        this.showMflag=false
      },
      mLayerConfirm:function(index){
        var that=this;
        // that.getSupplelist();
        // than.getPensionDetail();
        // console.log(index);
        axios.post('/user/delMPayment',qs.stringify({
          id:that.mPaymentList[index].id
        })).then((response)=>{
          if(response.data.code==22000){
            that.mPaymentList.splice(index,1);
            that.showMflag=false;
            this.getSupplelist();
            this.getPensionDetail();
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        });

      },
    },
    mounted:function(){
      var that=this;
      axios.get('/admin/company/list',{}).then((response)=>{
          if(response.data.code == 22000){
          that.companyData = response.data.result.list;
        }else if(response.data.code==50001){
          window.location.href='/#/login'
        }else{
          that.toast=true;
          that.toastContent=response.data.message;
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000)
        }
      });

      axios.get('/pensionAdjustment/getList',{}).then((response)=>{
        if(response.data.code == 22000){
          let pensionAdjustmentArr = response.data.result;
          let  tempArr = [];
          for (var i=0,j=pensionAdjustmentArr.length;i<j;i++){
            tempArr.push(pensionAdjustmentArr[i].years)
          }
          window.sessionStorage.setItem('key',tempArr)
        }else if(response.data.code !==22000){
          console.log(response.data.message)
        }
      });

      axios.get('/user/getInfo',{ params:{ id:that.id }}).then((response)=>{
        if(response.data.code==22000){
          var result = response.data.result;
          for (var key in result){
            that.userInfo[key]=result[key];
            for(var item in result[key]){

              that.userInfo[key][item] = result[key][item];
            }
          }
          window.sessionStorage.setItem('retirementTime',result.retirement.date)


          if(response.data.result.user.stop_time=='0000-00-00 00:00:00'){
            that.userInfo.user.stop_time = ''
          }else{
            that.userInfo.user.stop_time =  moment(that.userInfo.user.stop_time).format("YYYY-MM-DD")
          }

          if(response.data.result.user.status == 1){
              that.disabled = false
          }else {
            that.disabled = true
          }
          //判断是否有过渡期
          if(response.data.result.period.type == 0){
            that.interim = false
          }else{
            that.interim = true
          }
          //判断是否有军转干
          if(response.data.result.oldMethod.military_cadres !== 0){
            that.turnDry = true
          }else{
            that.turnDry = false
          }

        }else if(response.data.code == 50001){
          window.location.href='/#/login';
        }
     });
      axios.get('/config/getRetirementType').then((response)=>{
          if(response.data.code == 22000){
            that.retiredType = response.data.result;
          }else if(response.data.code == 50001){
            window.location.href='/#/login';
          }
      });
      //获取军转干下拉框列表
      axios.get('/config/getPersonnelType').then((response)=>{
          if(response.data.code == 22000){
          that.personnelType = response.data.result;
        }
      });
      that.getHistoryDetail();
      that.getSupplelist(); 
      that.getPensionDetail();
      that.searchPension();
      that.getMPaymentList()

      axios.get('/config/getArmyPosition',{}).then((response)=>{
        if(response.data.code == 22000){
          that.positionArmy = response.data.result;
        }else if(response.data.code !==22000){
          console.log(response.data.message)
        }
      });

      axios.get('/config/getTechRank',{}).then((response)=>{
        if(response.data.code == 22000){
          that.techRank = response.data.result;
        }else if(response.data.code !==22000){
          console.log(response.data.message)
        }
      });

    },
    watch:{
      'userInfo.user.domicile_province' : function(){
        this.updateCity('domicileCities',this.userInfo.user.domicile_province);
      },
      'userInfo.user.address_province' : function(){
        this.updateCity('addressCities',this.userInfo.user.address_province);
      },
      'userInfo.user.domicile_city' : function(){
        this.updateDistrict('domicileDistrict',this.userInfo.user.domicile_city,this.userInfo.user.domicile_province);

      },
      'userInfo.user.address_city' : function(){
        this.updateDistrict('addressDistrict',this.userInfo.user.address_city,this.userInfo.user.address_province);
      },
      'userInfo.special.type' : function(){
        this.getPositionInfo(this.userInfo.special.type,'special')
      },
      'userInfo.retirement.rank':function(){
        this.getPositionInfo(this.userInfo.retirement.rank,'retirement')
      },
      'userInfo.period.type':function(){
        this.getPositionInfo(this.userInfo.period.type,'period')
      }

    }

  }
</script>
<style lang="less">
  .w_375{
    width: 375px!important;;
  }
  .w100{
    width:85%!important;
  }
  .flex{
    display: flex;
    width:90%;
  }
  .auto_flex{
    flex:.94;
  }
  .table_outer_box{
    margin-bottom: 30px;
  }
  .history_info_box{
    position: relative;
  .line_box{
    position: absolute;
    left: 91px;
    height: 100%;
    border-right: 1px solid #e1e7f6;
  }
  .history_info{
    /*padding-left: 39px;*/
    margin-bottom: 40px;
  .history_left{
    float: left;
    width: auto;
    text-align: right;
  }
  .history_right{
    float: left;
    margin-left: 50px;
  p{
    color: #32363a;
  span{
    color: #32363a;
  }
  .edition_change_info{
    margin-left: 10px;
    color: #aaa;
  }
  }
  .history_info_tit{
    position: relative;
    margin-bottom: 10px;
  .blue_dot{
    position: absolute;
    top:9px;
    left: -6px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #0080ea;
  }
  }
  }
  }
  }
  .date_picker_out{
    padding:0!important;
  input{
    border:none !important;
    width:100%!important;
  }
  }
  .operation_list{
    position:absolute;
    right:20px;
    top:0;
  li{
    cursor: pointer;
    padding-left: 30px;
    margin-left: 22px;
    line-height: 50px;
  }
  }
  .layer_content{
    text-align: center;
    line-height: 80px;
    font-size: 16px;
  }
  .shiftHide{
    display: none;
  }
  .shiftShow{
    display: block;
  }
  .errorMessage{
    width: 200px;
    bottom: -18px;
}
</style>



// WEBPACK FOOTER //
// src/components/seeList/retireSee.vue